import { useLayoutEffect } from 'react'

export const MAX_HEIGHT = 1000

export const useOneQuarterHeightAuthority = (oneRef: React.RefObject<HTMLElement>) => {
  useLayoutEffect(() => {
    const el = oneRef.current
    if (!el) return

    const update = () => {
      const h = Math.min(el.getBoundingClientRect().height, MAX_HEIGHT)
      document.documentElement.style.setProperty('--one-quarter-height', `${h}px`)
    }

    const ro = new ResizeObserver(update)
    ro.observe(el)
    update()

    return () => {
      ro.disconnect()
      document.documentElement.style.removeProperty('--one-quarter-height')
    }
  }, [oneRef])
}
